/* eslint-disable react/no-unescaped-entities */
import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { Button, Alert } from 'shpmtcd'
import { Link } from 'react-router-dom'
import EmailField from './Email_withIndicator'
import Recaptcha from '../../../shared/recaptcha'

const ForgotPassword = ({
  email, indicatorStatus, success, message,
  onChangeEmail, onSendInstructions, footerLink, onUnmount,
  populateDefaultEmail,
}) => {
  const recaptchaRef = useRef()
  const [isEnabled, setButtonEnable] = useState(0)

  useEffect(() => {
    // eslint-disable-next-line no-use-before-define
    handleInputChange()
  }, [email])

  useEffect(() => {
    populateDefaultEmail()
  }, [])

  useEffect(() => () => {
    onUnmount()
  }, [])

  const handleSumbit = () => {
    const captcha = recaptchaRef.current.getCaptchaStateValue()
    onSendInstructions(captcha)
  }

  const handleInputChange = (captcha) => {
    const emailBool = email.value.length && email.isValid
    const captchaBool = captcha || recaptchaRef.current.getCaptchaStateValue()

    setButtonEnable(emailBool && captchaBool)
  }

  return (
    <section className='account-form-wrapper'>
      <div className='title'>Forgot password</div>
      <div className='send-instructions'>
        <p className='description'>
          Enter your email address, and we'll send instructions on how to create a new password.
        </p>
        <EmailField
          labelText=''
          showIndicator={indicatorStatus}
          placeholder='Email'
          value={email.value}
          isValid={email.isValid}
          validationMessages={email.validationMessages || ''}
          onEmailChange={onChangeEmail}
        />
        <Recaptcha
          ref={recaptchaRef}
          handleChange={(captcha) => handleInputChange(captcha)}
        />
        {message ? (
          <Alert
            type={success ? 'success' : 'error'}
            message={message}
            showIcon
          />
        ) : null}
        <Button
          type='Primary'
          className='send-instructions-btn'
          onClick={handleSumbit}
          disabled={!isEnabled}
        >
          Send instructions
        </Button>
      </div>
      {footerLink.link ? (
        <div className='back-to-login'>
          <Link to={footerLink.link}> {footerLink.text}</Link>
        </div>
      ) : null}
    </section>
  )
}

ForgotPassword.propTypes = {
  email: PropTypes.shape({
    value: PropTypes.string.isRequired,
    isValid: PropTypes.bool.isRequired,
    validationMessages: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
  indicatorStatus: PropTypes.bool.isRequired,
  onChangeEmail: PropTypes.func.isRequired,
  onSendInstructions: PropTypes.func.isRequired,
  success: PropTypes.bool,
  message: PropTypes.string,
  onUnmount: PropTypes.func.isRequired,
  populateDefaultEmail: PropTypes.func.isRequired,
  footerLink: PropTypes.shape({
    text: PropTypes.string,
    link: PropTypes.string,
  }),
}

ForgotPassword.defaultProps = {
  success: null,
  message: null,
  footerLink: {
    text: '',
    link: '',
  },
}

export default ForgotPassword
